import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import 'devextreme-react/text-area';
import ScrollView from 'devextreme-react/scroll-view';
import { RadioGroup } from 'devextreme-react/radio-group';
import { Button } from 'devextreme-react/button';
import ResponsiveBox, { Row, Col, Item, Location } from 'devextreme-react/responsive-box';
import notify from 'devextreme/ui/notify';
import FileUploader from 'devextreme-react/file-uploader';
import saveAs from 'file-saver';
import OrderApi from '../../../api/order';
import url from '../../../api/base-url';
import sessions from '../../../sessions';
import './import-dialog.scss';

const ImportDialog = forwardRef((props, ref) => {
    const fileUploadRef = useRef();
    const [valueSelectionOne, setValueSelectionOne] = useState(0);
    const [valueSelectionTwo, setValueSelectionTwo] = useState(0);
    const [showRemoveBtn, setShowRemoveBtn] = useState(false);
    const [filePath, setFilePath] = useState('');
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    const selectionOne = [
        { text: `Identify products uniquely by SKU`, value: 0 },
        { text: `Identify products uniquely by Name`, value: 1 }
    ]

    const selectionTwo = [
        { "text": `Update product information if the products already exist`, "value": 0 },
        { "text": `Ignore any products that already exist (only new products will be imported)`, "value": 1 }
    ]

    const itemRender = (item) => {
        const itemsStyle = { margin: '5px', fontSize: '12px' }
        return (
            <>
                <p style={itemsStyle}>{item.text}</p>
            </>
        );
    }

    const downloadBtn = () => {
        saveAs("https://www.dropbox.com/s/up4xyl8ftwpzqq7/order-template.csv?dl=1", 'template.csv');
    }

    const removeFile = () => {
        fileUploadRef.current.instance.reset()
        setShowRemoveBtn(false)
    }

    const handleSubmit = async () => {
        if(!filePath.includes(".csv")) {
            notify("File must be csv!", "warning", 2000);
            return 
        }
        let dataSend = {
            identifyBySKU: valueSelectionOne,
            replaceData: valueSelectionTwo,
            filePath: filePath,
            userId: userId
        }
        await OrderApi.importOrderProduct(userId,dataSend,auth).then(res => {
            if(res.data.success === true) {
                notify("order data inserted succesfully", "success", 500);
                props.closeImportDialog()
            } 
            else if(res.data.success === false) {
                notify(res.data.msg.message, "error", 2000);
                return false
            }
            else {
                notify("Something is wrong!", "error", 2000);
                return false
            }
        }).catch((err) => console.log(err));

    }

    const onUploaded = (e) => {
        let response = JSON.parse(e.request.response)
        setFilePath(response.data.path)
        setShowRemoveBtn(true)
    }
    
    useImperativeHandle(ref, (e) => ({ handleSubmit }));

    return (
        <React.Fragment>
            <ScrollView>
                {/* <form id="order-form" ref={formElement} method="post" action={`${url}/import/orderImport`} encType="multipart/form-data"> */}
                <ResponsiveBox>
                    <Row />
                    <Row />
                    <Row />
                    <Row />
                    <Row />
                    <Col />
                    <Col />
                        <Item>
                            <Location row={0} col={0} colspan={2} />
                            <p style={{fontSize: 12}}>If you'd like to import product information from a spreadsheet or other datasource, you can provide your data in our standard CSV file format. As products are imported we will create products that do not already exist and optionally update existing products.</p>
                            <p style={{ fontSize: 12, marginTop: 10, marginBottom: 20 }}><a style={{cursor: 'pointer'}} onClick={() => downloadBtn()}>Download a sample CSV file</a></p>
                            <p style={{ fontSize: 12, fontWeight: 'bold' }}>1. Select a File to Import</p>
                        </Item>
                        <Item>
                            <Location row={1} col={0} />
                            <FileUploader 
                                ref={fileUploadRef}
                                selectButtonText="Select file" 
                                labelText=""
                                name="files"
                                uploadUrl={`${url}/upload`}
                                onUploaded={onUploaded}
                                accept={".csv, text/csv"}/>
                        </Item>
                        <Item>
                            <Location row={1} col={1} />
                            <br />
                            <Button visible={showRemoveBtn} text="Remove File" onClick={removeFile} />
                        </Item>
                        <Item>
                            <Location row={2} col={0} colspan={2} />
                            <p style={{ fontSize: 12, fontWeight: 'bold', marginTop: 20 }}>2. Select Options</p>
                            <br />
                            <p style={{ fontSize: 12 }}>As products are imported, we will attempt to identify whether they already exist. You can select which field uniquely identifies a product.</p>
                            <br />
                            <RadioGroup
                                dataSource={selectionOne}
                                value={valueSelectionOne}
                                itemRender={itemRender}
                                valueExpr={'value'}
                                onValueChanged={e => setValueSelectionOne(e.value)}
                            /> 
                        </Item>
                        <Item>
                            <Location row={3} col={0} colspan={2} />
                            <br />
                            <p style={{ fontSize: 12 }}>You can choose to update products if they already exist or to only import new products.</p>
                            <br />
                            <RadioGroup
                                dataSource={selectionTwo}
                                value={valueSelectionTwo}
                                itemRender={itemRender}
                                valueExpr={'value'}
                                onValueChanged={e => setValueSelectionTwo(e.value)}
                            /> 
                        </Item>
                </ResponsiveBox>
                {/* </form> */}
            </ScrollView>
        </React.Fragment>
    )

})

export default ImportDialog;